module.exports = __webpack_public_path__ + "static/media/us_creteil_generale.390b5ec7.png";